const SCOPE = 'checklist-item';
const CHECKLIST_SCOPE = 'checklist-alerts';

const getRowScope = itemId => `row-${itemId}`;

export const AlertsTestIds = {
  VIEW_RESULT_BUTTON: `${SCOPE}.view-result-button`,
  GO_TO_FIELD_BUTTON: `${SCOPE}.go-to-field-button`,
  ACTION_BUTTON: `${SCOPE}.action-button`,
  CREATE_TASK_BUTTON: `${SCOPE}.create-task-button`,

  CHECKLIST_STATUS_LABEL: `${CHECKLIST_SCOPE}.status-label`,
  PENDING_CHANGES_LABEL: `${CHECKLIST_SCOPE}.pending-changes-label`,

  getItemRowId: itemId => `${SCOPE}.${getRowScope(itemId)}`,
  getItemStatusLabelId: itemId => `${getRowScope(itemId)}.status-label`,
  getItemStateReasonId: itemId => `${getRowScope(itemId)}.state-reason-label`,
  getItemActionsButtonId: itemId => `${getRowScope(itemId)}.actions-button`,
  getItemActionId: (itemId, slug) => `${getRowScope(itemId)}.action-${slug}`,
};
